import { useMutation } from "@tanstack/react-query";
import { CurrentUserType } from "providers/types";

const trackUserAnalytics = async (user: CurrentUserType) => {
  window.analytics.identify(user.id, {
    email: user.email,
    name: `${user.first_name} ${user.last_name}`,
    Role: user.role.name || "default",
    Company: user.company.name,
    "Account Type": user.type,
    "First Name": user.first_name,
    "Last Name": user.last_name,
    "Job Title": user.job_title,
    "Company Type": user.company.type,
    "KYC Verified": user.kyc_verified ? true : false,
  });
};

export const useTrackUserAnalytics = () => {
  return useMutation({
    mutationFn: trackUserAnalytics,
  });
};
